export default "__VITE_ASSET__Cp2fH9kg__"